<template>
  <div>
    <img alt="" class="other-banner" src="../assets/imgs/service-banner.png">
    <div class="wrap">
      <p class="img-title">
        <img alt="" src="../assets/imgs/service-img-title.png">
      </p>
      <section class="section-1">
        <img alt="" src="../assets/imgs/service-section-1-1.png">
        <div>成都辰微沐阳心理诊所，是隶属于辰微沐阳心理健康集团公司的实体心理健康综合服务医疗机构，辰微沐阳心理品牌始创于2019年，专注于心理健康的区域化落地应用，具有雄厚的心理领域专业技术实力。</div>
      </section>
      <section class="section-2">
        <div><img alt="" src="../assets/imgs/service-section-2-1.png"></div>
        <div><img alt="" src="../assets/imgs/service-section-2-2.png"></div>
        <div><img alt="" src="../assets/imgs/service-section-2-3.png"></div>
      </section>
      <section class="section-3">
        <div>
          辰微沐阳心理位于成都市武侯区华西健康谷B区1栋3单元305号，占地面积422.8平方米，总投入近1000万，设有多个心理咨询室、团辅室、测评室、沙盘室等专业心理诊疗场域，接诊医师、咨询师近50名，擅长处理：网络成瘾、进食障碍、睡眠障碍、厌学问题、情绪问题、心境障碍等其它与心理因素密切相关的精神心理障碍。
        </div>
      </section>
      <section class="section-4">
        <img alt="" src="../assets/imgs/service-section-4-1.png">
        <div>辰微沐阳心理秉承现代“生物-心理-社会医学”模式、融合“医教结合”的新型诊疗理念，特色诊疗群体为青少年群体及附属的家庭单元，涵盖精神科诊疗、心理咨询及治疗、家庭教育、心理评估、社会心理综合服务等五大服务板块。
          <br/>
          辰微沐阳心理立足于心理健康领域，以打造本地整体化心理健康服务闭环模式为基础，聚焦于青少年心理健康领域，致力于为医疗、企业、政府等各类人群提供专业、优质、可信赖的整体式心理保健及诊疗服务。
        </div>
      </section>
      <section class="section-5">
        <img alt="" src="../assets/imgs/service-section-5-1.png">
        <div>
          公司拥有强大的多维技术力量，核心团队覆盖教育、心理、精神医学、法律、软件开发、大数据六大领域，拥有华西心理促进中心、家庭教育促进会、西部多元调处中心、四川心理学会等战略合作伙伴，专家智库囊括清华、北京宣武、华西、中国心理学会、中科院心理所、省未成年人心理研究中心、川师大、四川开放大学等多方心理领域建立友好合作关系。特聘华西心理卫生中心、四川省精神卫生中心、成都德康医院多位专家作为专家顾问团队成员，为开展青少年心理健康服务提供了坚强的人才技术支撑。
        </div>
      </section>
    </div>
    <div class="bottom">
      <p class="bottom-title">公司联系方式</p>
      <div class="wrap">
        <div>
          <p><img alt="" src="../assets/imgs/service-icon-1.png">
            手机号码</p>
          19180798602（微信同号）
        </div>
        <div>
          <p><img alt="" src="../assets/imgs/service-icon-2.png">
            座机号码</p>
          87779652
        </div>
        <div>
          <p><img alt="" src="../assets/imgs/service-icon-3.png">
            公众微信号</p>辰微沐阳CW
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "service",
  data(){
    return {
      options:{
        slidesPerView:1.5
      }
    }
  }
}
</script>

<style scoped>
.other-banner {
  object-fit: cover;
}

.section-1 {
  font-size: 0;
  margin-bottom: 10px;
}

.img-title {
  text-align: center;
}

.section-1 img {
  width: 890px;
  vertical-align: middle;
}

.section-1 div {
  padding: 25px;
  box-sizing: border-box;
  background: #353334;
  font-size: 16px;
  font-family: PingFang SC;
  line-height: 50px;
  color: #FFFFFF;
  vertical-align: top;
  height: 384.83px;
  display: inline-block;
  width: calc(100% - 890px);
}

.section-2 {
  display: flex;
  justify-content: space-between;
}

.section-2 div {
  overflow: hidden;
  width: 390px;
  height: 255px;
  cursor: pointer;
}

.section-2 div img {
  width: 100%;
  height: 100%;
  transition: all .3s linear;
}

.section-2 div:hover img {
  transform: scale(1.1);
}

.section-3 {
  width: 1000px;
  border: 1px dashed rgba(66, 170, 178, 1);
  padding: 0 25px 25px;
  border-top: 0px;
  box-sizing: border-box;
  margin: 0 auto;
}

.section-3 div {
  padding: 20px;
  box-sizing: border-box;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #353334;
  width: 100%;
  background: rgba(244, 244, 244, .5);
}

.section-4 {

  text-align: right;
}

.section-4, .section-5 {
  position: relative;
  margin-top: 50px;
}

.section-5 {
  text-align: left;
  margin-bottom: 20px;
}

.section-4 div {
  left: 0;
}

.section-5 div {
  right: 0;
}

.section-4 div, .section-5 div {
  position: absolute;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #0D0D0D;
  padding: 40px 20px;
  width: 840px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(234, 234, 234, .5);
  border-top: 1px solid rgba(66, 170, 178, .5);
  line-height: 30px;
  text-align: left;
}

.bottom {
  width: 100%;
  height: 278px;
  background: url("../assets/imgs/service-bottom-bg.png") no-repeat;
  background-size: cover;
  padding-top: 30px;
  box-sizing: border-box;
}

.bottom .bottom-title {
  text-align: center;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #F3F3F3;
  margin-bottom: 60px;
}

.bottom .wrap {
  display: flex;
  justify-content: space-between;
}

.bottom .wrap div {
  width: 317px;
  height: 108px;
  background: rgba(255, 255, 255, .3);
  border-radius: 3px;
  color: #D0D0D0;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  padding-top: 20px;
  box-sizing: border-box;
  text-align: center;
}

.bottom .wrap div p {
  margin-bottom: 10px;
}

.bottom .wrap div img {
  vertical-align: middle;
}

@media (max-width: 760px) {
  .section-1 img {
    width: 100vw;
  }

  .section-1 div {
    width: 100%;
    height: auto;
    line-height: .35rem;
    padding: .25rem;
    text-indent: 1em;
  }

  .section-2 {
    margin-top: .5rem;
    flex-wrap: wrap;
  }
  .section-2 div{
    width: 100%;
  }
  .section-3{
    width: 100%;
  }
  .section-3 div{
    width: 100%;
  }
  .section-4 img,.section-5 img{
    width: 100%;
  }
  .section-4 div,.section-5 div{
    box-sizing: border-box;
    width: 100%;
    padding: .3rem;
    height: 100%;
    overflow: hidden;
  }
  .bottom{
    height: auto;
  }
  .bottom .wrap{
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .bottom .wrap div{
    width: 80%;
    margin-bottom: .3rem;
  }
}
</style>
